export const SET_COMMANDES = 'SET_COMMANDES';
export const SET_TOTAL_COMMANDES = 'SET_TOTAL_COMMANDES';
export const SET_COMMANDE = 'SET_COMMANDE';
export const SET_COMMANDE_LASTDATAFROMLOAD = 'SET_COMMANDE_LASTDATAFROMLOAD';
export const REMOVE_COMMANDE = 'REMOVE_COMMANDE';
export const SET_CRITERE_RECHERCHE = 'SET_CRITERE_RECHERCHE';
